import React, { useMemo, useState } from 'react';
import { API_BASE } from './config/api';
import { clearAuthSession } from './authSession';
import './AuthPage.css';
import './TrialAccessPage.css';

const HERO_DESCRIPTION =
  'Пробный доступ закрыт. Чтобы снова подбирать поверхности, считать охват и собирать кампании — запросите открытие кабинета.';

function BrandMark({ fill = '#3B5EE9' }) {
  return (
    <svg width="24" height="21" viewBox="0 0 24 21" fill="none" aria-hidden>
      <path
        d="M12.8252 0.00553429C13.5238 0.00466141 14.2681 -0.00864774 14.9629 0.00944054L16.3281 1.35612C17.1603 1.40348 18.2089 1.37365 19.0596 1.3737L23.9785 1.37565L23.9766 4.94206C23.9778 5.8302 24.1586 6.97551 23.4893 7.63444C23.2976 7.82423 23.0604 7.96164 22.8008 8.03385C22.3898 8.14532 20.5827 8.09134 20.0332 8.10026L20.042 13.6149C19.0755 14.4848 17.9843 15.3355 17.0127 16.2087C16.6798 16.5079 16.0904 16.9461 15.8027 17.235C15.7804 18.1798 15.7912 19.1929 15.7988 20.1413C14.4341 20.1442 13.0334 20.1256 11.6738 20.1462C11.6744 19.2108 11.6564 18.2089 11.6807 17.279L5.28516 17.277C5.06517 18.1646 4.80853 19.2789 4.5459 20.1423H0C0.234441 19.011 0.43135 17.7061 0.616211 16.5612L1.29395 12.4294L1.77734 9.49772C1.84715 9.0903 1.99566 8.38845 2.03711 8.01042C2.15221 7.94336 2.88744 7.9723 3.08008 7.97233H5.0957C6.79086 7.97211 8.61717 7.93918 10.3027 7.98014C10.8741 7.36907 11.4878 6.7869 12.0742 6.1901C12.2984 5.96199 12.6176 5.67045 12.8242 5.43717C12.83 3.64114 12.8449 1.80052 12.8252 0.00553429ZM19.9941 14.4958C20.0663 14.5668 20.041 15.7394 20.041 15.9118L20.043 18.8512C20.0417 19.1121 20.0171 19.9191 20.0537 20.1432H16.8789C16.7575 20.1477 16.6823 20.1563 16.5645 20.1198C16.4902 19.8305 16.5485 17.868 16.5488 17.4479C16.997 17.0301 17.5495 16.5891 18.0234 16.1911C18.6872 15.634 19.3441 15.0688 19.9941 14.4958ZM8.87988 17.9049C8.85453 18.6081 8.87522 19.4291 8.87793 20.1413L8.28516 20.1432L5.22754 20.1393C5.4198 19.5931 5.66498 18.5256 5.83789 17.9079L8.87988 17.9049ZM18.2441 3.12663C17.6785 3.12759 17.0846 3.13804 16.5215 3.12858L16.5195 4.27702L18.2432 4.27311L18.2441 3.12663Z"
        fill={fill}
      />
    </svg>
  );
}

function HeroMark() {
  return (
    <svg className="kb-auth-hero-mark" viewBox="0 0 24 21" fill="none" aria-hidden>
      <path
        d="M12.8252 0.00553429C13.5238 0.00466141 14.2681 -0.00864774 14.9629 0.00944054L16.3281 1.35612C17.1603 1.40348 18.2089 1.37365 19.0596 1.3737L23.9785 1.37565L23.9766 4.94206C23.9778 5.8302 24.1586 6.97551 23.4893 7.63444C23.2976 7.82423 23.0604 7.96164 22.8008 8.03385C22.3898 8.14532 20.5827 8.09134 20.0332 8.10026L20.042 13.6149C19.0755 14.4848 17.9843 15.3355 17.0127 16.2087C16.6798 16.5079 16.0904 16.9461 15.8027 17.235C15.7804 18.1798 15.7912 19.1929 15.7988 20.1413C14.4341 20.1442 13.0334 20.1256 11.6738 20.1462C11.6744 19.2108 11.6564 18.2089 11.6807 17.279L5.28516 17.277C5.06517 18.1646 4.80853 19.2789 4.5459 20.1423H0C0.234441 19.011 0.43135 17.7061 0.616211 16.5612L1.29395 12.4294L1.77734 9.49772C1.84715 9.0903 1.99566 8.38845 2.03711 8.01042C2.15221 7.94336 2.88744 7.9723 3.08008 7.97233H5.0957C6.79086 7.97211 8.61717 7.93918 10.3027 7.98014C10.8741 7.36907 11.4878 6.7869 12.0742 6.1901C12.2984 5.96199 12.6176 5.67045 12.8242 5.43717C12.83 3.64114 12.8449 1.80052 12.8252 0.00553429ZM19.9941 14.4958C20.0663 14.5668 20.041 15.7394 20.041 15.9118L20.043 18.8512C20.0417 19.1121 20.0171 19.9191 20.0537 20.1432H16.8789C16.7575 20.1477 16.6823 20.1563 16.5645 20.1198C16.4902 19.8305 16.5485 17.868 16.5488 17.4479C16.997 17.0301 17.5495 16.5891 18.0234 16.1911C18.6872 15.634 19.3441 15.0688 19.9941 14.4958ZM8.87988 17.9049C8.85453 18.6081 8.87522 19.4291 8.87793 20.1413L8.28516 20.1432L5.22754 20.1393C5.4198 19.5931 5.66498 18.5256 5.83789 17.9079L8.87988 17.9049ZM18.2441 3.12663C17.6785 3.12759 17.0846 3.13804 16.5215 3.12858L16.5195 4.27702L18.2432 4.27311L18.2441 3.12663Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function TrialAccessPage({ access }) {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [statusText, setStatusText] = useState('');
  const [errorText, setErrorText] = useState('');

  const trialEndText = useMemo(() => {
    if (!access?.trialEndsAt) return '';
    const date = new Date(access.trialEndsAt);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('ru-RU');
  }, [access?.trialEndsAt]);

  const submitAccessRequest = async () => {
    const token = localStorage.getItem('authToken');
    if (!token || sending) return;

    setSending(true);
    setStatusText('');
    setErrorText('');
    try {
      const response = await fetch(`${API_BASE}/auth/request-access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ message }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setErrorText(data?.message || 'Не удалось отправить запрос. Попробуйте позже.');
        return;
      }
      setStatusText(data?.message || 'Запрос отправлен, скоро свяжемся с вами.');
    } catch {
      setErrorText('Сервер недоступен. Попробуйте позже.');
    } finally {
      setSending(false);
    }
  };

  const logout = () => {
    clearAuthSession();
    window.location.assign('/auth');
  };

  return (
    <div className="kb-auth kb-trial">
      <section className="kb-auth-hero" aria-label="О продукте">
        <HeroMark />
        <div className="kb-auth-hero-copy">
          <h2 className="kb-auth-hero-brand">Купи.баннер</h2>
          <p className="kb-auth-hero-text">{HERO_DESCRIPTION}</p>
        </div>
        <button type="button" className="kb-auth-hero-link" onClick={logout}>
          Выйти из аккаунта
        </button>
      </section>

      <section className="kb-auth-panel" aria-label="Запрос доступа">
        <div className="kb-auth-panel-brand">
          <BrandMark />
          <span>Купи.баннер</span>
        </div>

        <div className="kb-auth-panel-body">
          <div className="kb-auth-form kb-trial-form">
            <div className="kb-auth-form-main">
              <h1>Пробный период закончился</h1>
              <p className="kb-trial-lead">
                Бесплатный доступ на 7 дней завершён
                {trialEndText ? ` ${trialEndText}` : ''}.
              </p>
              <p className="kb-auth-hint">
                Оставьте комментарий, если нужно, и нажмите кнопку — мы получим письмо и откроем доступ.
              </p>

              <div className="kb-auth-form-block">
                <label className="kb-auth-field" htmlFor="kb-trial-message">
                  <span>Комментарий</span>
                  <textarea
                    id="kb-trial-message"
                    className="kb-trial-textarea"
                    rows={4}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Необязательно"
                  />
                </label>
              </div>
            </div>

            <div className="kb-auth-actions kb-trial-actions">
              <button
                className="kb-auth-submit"
                type="button"
                onClick={submitAccessRequest}
                disabled={sending}
              >
                {sending ? 'Отправляем...' : 'Запросить доступ'}
              </button>
              <button className="kb-auth-ghost" type="button" onClick={logout}>
                Выйти
              </button>
            </div>

            {statusText ? <p className="kb-trial-ok">{statusText}</p> : null}
            {errorText ? <p className="kb-auth-error">{errorText}</p> : null}
          </div>
        </div>
      </section>
    </div>
  );
}
